/**
 * Mobile popup menu
 */
export function openMenuPopup() {
    $('.menu-hamburger').toggleClass('active');
    $('body').toggleClass('ovh');
    $('.pop-up-meniu').fadeToggle();
    $('.main_menu').toggleClass('deactiveLvlMenu');
}

/**
 * Format select2 text options
 *
 * @param d
 * @returns {string|*}
 */
export function formatSelect2TextOption(d) {
    let text = d.text;
    let parts = text.split('|||');

    if (parts.length === 1) {
        return parts[0];
    } else {
        return '<div class="select2_title">' + parts[0] + '</div>' + '<div class="select2_sub_line">' + parts[1] + '</div>';
    }
}

/**
 * Format select2 text selected
 *
 * @param d
 * @returns {*|string}
 */
export function formatSelect2TextSelected(d) {
    let text = d.text;
    let parts = text.split('|||');

    return parts[0];
}

/**
 * Select2 ajax input
 *
 * @param selectBox
 */
export function select2Ajax(selectBox) {
    let url = selectBox.data('url'),
        placeholder = selectBox.attr('placeholder'),
        minLength = selectBox.data('min-length');

    if (typeof (placeholder) == 'undefined') {
        placeholder = '';
    }

    let selectParams = {
        placeholder: placeholder,
        allowClear: true,
        width: '100%',
        escapeMarkup: function (markup) {
            return markup;
        },
        minimumInputLength: (minLength !== '' && minLength !== undefined) ? minLength : 1,
        templateResult: formatSelect2TextOption,
        templateSelection: formatSelect2TextSelected,
    };

    if (!selectBox.hasClass('select2-default-search')) {
        selectParams.ajax = {
            url: url,
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    q: params.term,
                    page: params.page
                };
            },
            processResults: function (data, params) {
                params.page = params.page || 1;
                return {
                    results: data.items,
                    pagination: {
                        more: (params.page * 30) < data.total_count
                    }
                };
            },
            cache: true
        };
    }

    selectBox.select2(selectParams);
}

/**
 * HTML loader
 *
 * @returns {string}
 */
export function htmlLoader() {
    return '<div class="overlay justify-content-center" style="display: none;">' +
        '<div class="spinner-border" role="status"></div>' +
        '</div>';
}

/**
 * Show or hide dynamic fields according to select value
 *
 * @param selectItem
 */
export function showDynamicField(selectItem) {
    selectItem.closest('div.row').find('.dynamic-field').hide().find('input, select').attr('disabled', true);

    selectItem.each(function () {
        let _this = $(this),
            value = _this.val(),
            displayOptions = _this.parent('div').find('.display-options').html();

        if (displayOptions.length > 0) {
            displayOptions = JSON.parse(displayOptions);

            $.each(displayOptions, function (key, val) {
                val = val === null ? val : val.toString();

                if (value === val) {
                    $('.dynamic-field.field-' + val).show().find('input, select').attr('disabled', false);
                }
            });
        }
    });
}

/**
 * Flash notifications
 *
 * @param type
 * @param title
 * @param message
 */
export function notify(type, title, message) {
    if (typeof window.stackBottomRight === 'undefined') {
        window.stackBottomRight = new Pnotify.Stack({
            dir1: 'down',
            dir2: 'left',
            firstpos1: 25,
            firstpos2: 25,
            push: 'bottom',
            context: $('.notify-container .pnotify-block').get(0),
            maxStrategy: 'close',
            maxOpen: 3,
            positioned: false,
            modal: false
        });
    }

    Pnotify.alert({
        type: type,
        title: title,
        text: message,
        stack: window.stackBottomRight,
        delay: 4000,
        animation: 'fade',
        textTrusted: true,
        titleTrusted: true,
        sticker: false,
        closerHover: false
    });
}

/**
 * Add 'collapsed' class to toggle button (necessary for expand/collapse icon display)
 *
 * @param selector
 */
export function addCollapsedClass(selector) {
    selector.find('.btn[data-toggle=collapse]').each(function () {
        if ($(this).attr('aria-expanded') === 'false') {
            $(this).addClass('collapsed');
        }
    });
}

/**
 * Show collapse if there is an error inside
 *
 * @param selector
 */
export function collapseIfHasError(selector) {
    let element = selector.find('.has-error');

    setTimeout(function () {
        element.closest('.collapse').collapse('show');
    }, 10);
}

/**
 * Application registration, upload files form's table handler
 *
 * @param fileType
 * @param file
 */
export function applicationFileUploadHandler(fileType, file) {
    let parent = $('input[name="' + fileType + '"]').closest('tr'),
        date = Moment(new Date(file.lastModified)).format('YYYY-MM-DD'),
        size = file.size / 1000,
        fileUpload = parent.find('td .table-file-upload'),
        fileData = parent.find('#file');

    notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['new_item_added']);
    Validator.removeError(parent.closest('.field'));

    parent.find('td .table-file-state').removeClass('status-red status-green status-none');
    parent.find('td .table-file-state').html(PREPARED_TO_UPLOAD).addClass('status-orange');
    parent.find('td .table-file-name').html(file.name);
    parent.find('td .table-file-date').html(date);
    parent.find('td .table-file-size').html((size).toString());
    parent.find('td .table-file-delete').removeClass('disabled d-none');
    parent.find('td .table-file-info').addClass('d-none');
    fileUpload.valid();
    fileUpload.parent('label').addClass('disabled d-none');
    fileData.val(JSON.stringify($.extend(JSON.parse(
            fileData.val()),
        {
            name: file.name,
            size: size,
            date: date
        }
    )));
}

/**
 * Application registration, upload files form's table handler
 *
 * @param fileType
 */
export function applicationFileDeleteHandler(fileType) {
    let parent = $('input[name="' + fileType + '"]').parents('tr');

    addNotSubmittedClass(parent.closest('form'));

    if (parent.length > 0) {
        let empty = '-',
            fileUpload = parent.find('td .table-file-upload'),
            fileData = parent.find('#file');

        notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['item_deleted']);
        Validator.removeError(parent.closest('.field'));

        parent.find('td .table-file-state').removeClass('status-red status-green status-orange');
        parent.find('td .table-file-state').html(NOT_PREPARED).addClass('status-none');
        parent.find('td .table-file-name').html(empty);
        parent.find('td .table-file-date').html(empty);
        parent.find('td .table-file-size').html(empty);
        parent.find('td .table-file-delete').addClass('disabled d-none');
        fileUpload.removeAttr('disabled').val('').valid();
        fileUpload.parent('label').removeClass('disabled d-none');
        fileData.val(JSON.stringify($.extend(
            JSON.parse(fileData.val()),
            {
                name: '',
                size: '',
                date: ''
            }
        )));
    }
}

/**
 * Add list item
 *
 * @param selectBox
 */
export function addListItem(selectBox) {
    let overlay = $('#' + selectBox.data('overlay-id')),
        selectedOption = selectBox.find(':selected'),
        ddList = $(selectBox.data('content-body')).find('.dd-list'),
        listItemCount = ddList.find('li.dd-item').length,
        maxListItems = parseInt(ddList.data('dd-max-length'));

    if (listItemCount < maxListItems) {
        overlay.show();
        setTimeout(function () {
            $.ajax({
                type: 'POST',
                dataType: 'html',
                data: {
                    _token: CSRF_TOKEN,
                    additionalData: selectedOption.data('additional')
                },
                cache: false,
                url: selectBox.data('content-url'),
                success: function (data) {
                    if (ddList.find('li.dd3-item[data-id="' + selectedOption.val() + '"]').length) {
                        notify('error', LANG_NOTIFY['error'], LANG_NOTIFY['item_exists']);
                    } else {
                        NestableComp.addNestableItem(ddList, data);
                        NestableComp.handleNestableItemsOrder(ddList.find('.dd-item-order'));
                        notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['new_item_added']);
                    }

                    selectBox.select2('val', ' ');
                    selectedOption.attr('disabled', true);

                    if (listItemCount === (maxListItems - 1) && selectBox.prop('disabled') === false) {
                        selectBox.prop('disabled', 'disabled');
                    }

                    Init.initJs(ddList);
                    overlay.hide();
                },
                error: function () {
                    notify('error', LANG_NOTIFY['error'], SOMETHING_WENT_WRONG);
                    overlay.hide();
                }
            });
        }, 100);
    } else {
        Fnc.notify('error', LANG_NOTIFY['error'], MAX_NUMBER_OF_PREFERENCES_REACHED);
    }
}

/**
 * Add not-submitted class to form
 *
 * @param element
 */
export function addNotSubmittedClass(element) {
    element.closest('form').addClass('not-submitted').trigger('classChange');
}

/**
 * Check if dependent fields are filled by id
 *
 * @param id
 * @returns {boolean}
 */
export function checkDependentFields(id) {
    let filled = true;

    $('form').find('.dependent[data-depend-id=' + id + ']').each(function () {
        let val = $(this).val();

        if (val === '' || val === undefined || val === null) {
            filled = false;
        }
    });

    return filled;
}

/**
 * Get ajax response
 *
 * @param url
 * @param field
 * @param data
 * @returns {string}
 */
export function manageDependentValue(url, field, data) {
    let overlay = $('#' + field.data('overlay-id'));

    $.ajax({
        type: 'POST',
        data: data,
        cache: false,
        url: url,
        success: function (response) {
            if (response[FNC_ERROR_MESSAGE_PARAM] !== undefined) {
                notify('error', LANG_NOTIFY['error'], response[FNC_ERROR_MESSAGE_PARAM]);
            }
            setDependentValue(field, response);
            handleValSetter(field);
        },
        error: function () {
            notify('error', LANG_NOTIFY['error'], SOMETHING_WENT_WRONG);
        },
        beforeSend: function () {
            overlay.show();
        },
        complete: function () {
            overlay.hide();
        }
    });
}

/**
 * Get all dependent fields values by depend id
 *
 * @param id
 * @returns {{}}
 */
export function getDependentFieldValues(id) {
    let data = {};

    $('form').find('.dependent[data-depend-id]').each(function () {
        let _this = $(this);

        data[_this.attr('name')] = _this.val();
    });

    return data;
}

/**
 * Set dependent field values
 *
 * @param field
 * @param data
 */
export function setDependentValue(field, data) {
    if (field.hasClass('select')) {
        field.empty();

        setSelectOptions(
            field,
            data[field.attr('name')] !== undefined ? data[field.attr('name')] : data
        );

        field.val(field.data('depend-value')).change();
    } else if (field.is('input')) {
        field.val(data[field.attr('name')]).change();
    } else {
        field.html(data[field.attr('id')]).change();
    }

    showDynamicField(field);
}

/**
 * Empty and disable all dependent fields recursively
 *
 * @param fields
 */
export function emptyDependentFields(fields) {
    fields.each(function () {
        let id = $(this).data('depend-id');

        fields.attr('disabled', true).val('').empty().html('-');

        if (id !== undefined) {
            emptyDependentFields($('body').find('.dependent[data-depend-on=' + id + ']'));
        }
    });
}

/**
 * Disable all empty dependent fields
 */
export function disableEmptyDependentFields() {
    let body = $('body'),
        dependentFields = body.find('.dependent[data-depend-id]');

    $.each(dependentFields, function () {
        let _this = $(this),
            dependentField = _this.hasClass('dependent') ? _this : _this.find('.dependent'),
            id = dependentField.data('depend-id'),
            isFilled = checkDependentFields(id);

        if (!isFilled) {
            emptyDependentFields(body.find('.dependent[data-depend-on=' + id + ']'));
        }
    });
}

/**
 * Handle dependent fields
 *
 * @param container
 */
export function handleDependentFields(container) {
    let dependentField = container.hasClass('dependent') ? container : container.find('.dependent'),
        id = dependentField.data('depend-id'),
        fields = $('body').find('.dependent[data-depend-on=' + id + ']'),
        isFilled = Fnc.checkDependentFields(id);

    if (isFilled) {
        fields.each(function () {
            let _field = $(this),
                url = _field.data('depend-url');

            if (url !== undefined) {
                Fnc.manageDependentValue(
                    url,
                    _field,
                    Fnc.getDependentFieldValues(id)
                );
            }

            parseInt(_field.data('depend-disable')) ? _field.attr('disabled', true) : _field.attr('disabled', false);
        });
    } else {
        Fnc.emptyDependentFields(fields);
    }
}

/**
 * Set select field options
 *
 * @param select
 * @param options
 */
export function setSelectOptions(select, options) {
    select.append(new Option('', '', true, true)).trigger('change');

    $.each(options, function (key, val) {
        select.append(new Option(val.text, val.value, false, false)).trigger('change');
    });
}

/**
 * Set input field rules.
 *
 * @param field
 * @param rules
 */
export function setInputFieldRules(field, rules) {
    $.each(rules, function (rule, value) {
        field.attr(rule, value);
    });
}

/**
 * Manage dynamic rules for set fields.
 * Dynamic rules are taken from selected option's data attribute.
 *
 * @param selectContainer
 */
export function handleDynamicRules(selectContainer) {
    let ids = selectContainer.data('dynamic-rule-ids'),
        rules = selectContainer.find(':selected').data('rules');

    $.each(ids, function (key, value) {
        Fnc.setInputFieldRules($('#' + value), rules);
    });
}

/**
 * Disable additional document button if maximum number of files was reached
 */
export function disableDocumentAddButton() {
    if ($('.document-list').find('.document-additional').length === 10) {
        $('.document-add').attr('disabled', true);
    }
}

/**
 * Disable / enable input elements according to checkbox property
 *
 * @param checkbox
 */
export function toggleButton(checkbox) {
    $(`[data-toggle-btn-class='${checkbox.data('toggle-btn')}'`).each(function () {
        let _this = $(this),
            attribute = _this.data('toggle-btn-type') === 'readonly' ? 'readonly' : 'disabled';

        if (checkbox.is(':checked')) {
            _this.attr(attribute, false);
        } else {
            _this.attr(attribute, true);
            setReadonlyToRadioContent();
            // Remove validation block
            _this.closest('.field').removeClass('has-error').find('span.help-block').remove();
        }
    });
}

/**
 *  Set readonly to radio content inputs
 */
export function setReadonlyToRadioContent() {
    let radioContentInput = $('.radio-content').parent('div'),
        checkedRadio = $('.radio-box-group input:radio:checked'),
        inputName = checkedRadio.val(),
        input = $('#' + inputName);

    // Set readonly property for all radio content inputs
    radioContentInput.find('.radio-content').attr('readonly', true);

    // Unset readonly property from selected radio button input
    if (input.val() !== undefined && checkedRadio.attr('readonly') !== 'readonly') {
        input.attr('readonly', false);
    }
}

/**
 * Fade out global overlay page on load
 *
 * @param container
 */
export function showGlobalLoadingOverlay(container) {
    let loader = container.find('#loading-overlay.overlay');

    loader.removeClass('d-none').fadeOut(500, function (elem) {
        $(elem).addClass('d-none');
    });
}

/**
 * Val setter element function.
 * Set select field's text to specified element by id.
 *
 * @param field
 */
function handleValSetter(field) {
    let id = field.data('val-setter');

    if (id !== undefined) {
        let value = field.find(':selected').text();

        if (value !== '') {
            $('#' + id).html(value).val(value);
        }
    }
}

/**
 * Load PDF document viewer
 *
 * @param parentContainer
 * @param view
 */
export function loadPDFViewer(parentContainer, view) {
    let data = $(view).find('input[name="document"]').val();

    if (data !== undefined) {
        let loadingTask = PDFjs.getDocument({data: atob(data)});

        loadingTask.promise.then(function (pdf) {
            let __TOTAL_PAGES = pdf.numPages;
            let pageNumber = 1;

            for (let i = 1; i <= __TOTAL_PAGES; i += 1) {
                let id = 'the-canvas-' + i;
                parentContainer.find('.pdf-view').append("<canvas id='" + id + "'></canvas>");
                let canvas = $('#' + id)[0];

                renderPage(canvas, pdf, pageNumber++, function pageRenderingComplete() {
                    if (pageNumber > pdf.numPages) {
                        return;
                    }
                    renderPage(canvas, pdf, pageNumber++, pageRenderingComplete);
                });
            }
        });
    }
}

/**
 * Render pdf page
 *
 * @param canvas
 * @param pdf
 * @param pageNumber
 * @param callback
 */
function renderPage(canvas, pdf, pageNumber, callback) {
    pdf.getPage(pageNumber).then(function (page) {
        let context = canvas.getContext('2d');
        let viewport = page.getViewport({scale: 1.5});

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        canvas.style.width = '100% ';
        canvas.style.maxWidth = Math.floor(viewport.width) + 'px ';

        let renderContext = {
            canvasContext: context,
            viewport: viewport,
            background: '#f8f9fa'
        };

        page.render(renderContext).promise.then(callback);
    });
}

/**
 * Download document that is specified in hidden input
 *
 * @param container
 */
export function downloadDocument(container) {
    let docInput = container.find('input[name="document"]'),
        downloadLink = document.createElement('a');

    downloadLink.href = `data:application/octet-stream;base64,${docInput.val()}`;
    downloadLink.download = docInput.data('filename');
    downloadLink.click();
}

/**
 * Check if the current screen width corresponds to a mobile or tablet view.
 *
 * @returns {boolean} True if the screen width is less than or equal to 767px (typically mobile or tablet), otherwise false (typically desktop).
 */
export function isMobileOrTablet () {
    return window.matchMedia('(max-width: 767px)').matches;
}
